import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function StaticPage({ eyebrow, title, updated, children, testId }) {
  return (
    <div data-testid={testId} className="max-w-3xl mx-auto space-y-8">
      <Link to="/" className="sw-pill h-10 inline-flex text-sm" data-testid="static-back-home">
        <ArrowLeft size={14} /> Back to SenseWise
      </Link>
      <header>
        {eyebrow ? (
          <div className="text-xs uppercase tracking-widest text-[var(--sw-ink-soft)]">{eyebrow}</div>
        ) : null}
        <h1 className="display mt-1 text-4xl md:text-5xl font-extrabold leading-tight text-[var(--sw-primary-700)]">
          {title}
        </h1>
        <div className="sw-spectrum mt-4" aria-hidden />
        {updated ? (
          <p className="mt-4 text-sm text-[var(--sw-ink-soft)]">Last updated: {updated}</p>
        ) : null}
      </header>
      <article className="sw-card sw-card-spectrum sw-article p-6 md:p-10 max-w-none text-[var(--sw-ink)] leading-relaxed">
        {children}
      </article>
    </div>
  );
}
